/* 定制化客户的所有特殊功能，在前端做成配置化 */
export function getGlobalSpecialConfig() {
  return {
    needLoginAgreement: getNeedLoginAgreement(), // 是否需要登录的协议确认
    needChangeCompanyLogout: getNeedChangeCompanyLogout(), // 是否需要选择租户，提供退出登录按钮
    needPersonCenterLogout: getNeedPersonCenterLogout(), // 是否需要在个人中心提供退出登录按钮
  };
};

// 是否需要登录的协议确认
function getNeedLoginAgreement() {
  if (process.env.CUSTOMIZED_PROJECT === 'xtc') {
    return false;
  }
  return true;
}

// 是否需要选择租户的时候，可以退出登录重选
function getNeedChangeCompanyLogout() {
  if (process.env.CUSTOMIZED_PROJECT === 'xtc') {
    return false;
  }
  return true;
}

// 是否需要在个人中心提供退出登录按钮
function getNeedPersonCenterLogout() {
  if (process.env.CUSTOMIZED_PROJECT === 'xtc') {
    return false;
  }
  return true;
}
